import { useTransportTypeProduct } from '@components/Filters/Components/TransportTypeFilter/Provider';
import { useHotelVoucherItineraryIds } from '../providers/SearchResponseProvider';
import { useItinerary } from '@components/Results/Components/Itinerary/Provider';
import {
  pillComponents,
  PillTypes,
} from '@components/Results/Components/ThreeColumnsItinerary/PersuasiveTags/PersuasiveTags';
import { TransportType } from 'generated/graphql';

const defaultPillOrder: PillTypes[] = [
  'primeDay',
  'recommended',
  'cheapest',
  'priceFreeze',
  'hotelVoucher',
  'fastest',
  'earliest',
  'numNights',
  'carbonFootprint',
];

const semPillOrder: PillTypes[] = [
  'numNights',
  'primeDay',
  'recommended',
  'cheapest',
  'fastest',
  'carbonFootprint',
];

const useEnabledItineraryPills = (
  isSem,
  isPriceFreezeAvailable,
  loadingPriceFreeze,
  hasRetailingTechniques
): PillTypes[] => {
  const { carbonFootprint, highlightedType, campaignConfig, id } =
    useItinerary();
  const isHotelVoucher = useHotelVoucherItineraryIds().includes(id);
  const { isEco } = carbonFootprint || {};
  const { product } = useTransportTypeProduct();
  const isPrimeDayFare =
    campaignConfig?.primeDayConfig?.isPrimeDayFare &&
    campaignConfig?.primeDayConfig?.primeDayFareType &&
    campaignConfig?.primeDayConfig?.primeDayFareType !== 'BRONZE';

  const isPrimeDayPillDisplayed = isPrimeDayFare && hasRetailingTechniques;
  //lets save the name of pills that meet conditions and can be displayed
  const pillsAvailable = [
    isPrimeDayPillDisplayed && 'primeDay',
    !isPrimeDayPillDisplayed && isHotelVoucher && 'hotelVoucher',
    pillComponents[highlightedType] &&
      hasRetailingTechniques &&
      highlightedType,
    (isPriceFreezeAvailable || loadingPriceFreeze) && 'priceFreeze',
    isEco &&
      hasRetailingTechniques &&
      product !== TransportType.Train &&
      'carbonFootprint',
    isSem && hasRetailingTechniques && 'numNights',
  ] as PillTypes[];
  const pillsAvailableSet = new Set<PillTypes>(pillsAvailable);
  const pillsOrder = isSem ? semPillOrder : defaultPillOrder;

  return pillsOrder.filter((pill) => pillsAvailableSet.has(pill)).slice(0, 3);
};

export default useEnabledItineraryPills;
